
/**
 * 
 * @export
 * @interface VyzvaPublicZoznam
 */
export interface VyzvaPublicZoznam {
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'datumCasUzavretia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'datumObnovenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'datumVyhlasenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'datumZverejnenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'kod'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'komponent'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'oblast'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'opatrenie'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VyzvaPublicZoznam
     */
    'sprostredkovatelia'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'stav'?: VyzvaPublicZoznamStavEnum;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'vykonavatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'vyzvaId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'zoppmPodanieDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof VyzvaPublicZoznam
     */
    'zoppmPodanieOd'?: string;
}

export const VyzvaPublicZoznamStavEnum = {
    Nova: 'NOVA',
    Planovana: 'PLANOVANA',
    VPriprave: 'V_PRIPRAVE',
    KontrolaNika: 'KONTROLA_NIKA',
    NaDoplnenie: 'NA_DOPLNENIE',
    KontrolaUkoncena: 'KONTROLA_UKONCENA',
    Zverejnena: 'ZVEREJNENA',
    Pozastavena: 'POZASTAVENA',
    Uzatvorena: 'UZATVORENA',
    Vyhodnotena: 'VYHODNOTENA',
    RegistraciaZrusena: 'REGISTRACIA_ZRUSENA',
    Zrusena: 'ZRUSENA',
    PredPodpisomZmluvy: 'PRED_PODPISOM_ZMLUVY',
    ZmluvaUzavreta: 'ZMLUVA_UZAVRETA'
} as const;

export type VyzvaPublicZoznamStavEnum = typeof VyzvaPublicZoznamStavEnum[keyof typeof VyzvaPublicZoznamStavEnum];


